// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.97.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 56px;
  background-color: #f5f5f5;
  border-bottom-color: rgb(195, 195, 195);
  /* container-type: inline-size; */
}

h1 {
  font-size: 32px;
  font-weight: 700;
}

ul {
  margin-top: 24px;
  text-align: center;
  justify-content: center;
  display: flex;
  gap: 32px;
}

li {
  list-style-type: none;
  font-size: 24pt;
}

a {
  text-decoration: none;
  color: rgb(37, 85, 174);
  font-weight: 700;
}

a:hover {
  color: rgb(176, 12, 127);
}

@media (min-width:1050px)  { 
  .footer {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/sidebar/footer/footer.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".footer {\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding: 56px;\n  background-color: #f5f5f5;\n  border-bottom-color: rgb(195, 195, 195);\n  /* container-type: inline-size; */\n}\n\nh1 {\n  font-size: 32px;\n  font-weight: 700;\n}\n\nul {\n  margin-top: 24px;\n  text-align: center;\n  justify-content: center;\n  display: flex;\n  gap: 32px;\n}\n\nli {\n  list-style-type: none;\n  font-size: 24pt;\n}\n\na {\n  text-decoration: none;\n  color: rgb(37, 85, 174);\n  font-weight: 700;\n}\n\na:hover {\n  color: rgb(176, 12, 127);\n}\n\n@media (min-width:1050px)  { \n  .footer {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
